<ng-container
  *ngIf="!formData?.options?.editMode || formData?.options?.viewMode === 'show'"
>
  <div class="row show-mode custom-list">
    <ng-container *ngFor="let item of formData?.template">
      <ng-container *ngIf="item.type === 'arr-smart'">
        <mfpc-arr-smart-show-mode
          [item]="item"
          [formData]="formData"
          [optionList]="optionLists"
          [dateLocale]="dateLocale"
        ></mfpc-arr-smart-show-mode>
      </ng-container>

      <ng-container
        *ngIf="
          item.type !== 'arr-smart' &&
          item.type !== 'file' &&
          item.type !== 'file-multi'
        "
      >
        <div
          [ngClass]="item.gridClasses"
          class="{{
            formData?.options?.hideShowEmptyField &&
            !item.value &&
            !formData?.data[item.formControlName]
              ? 'p0'
              : ''
          }}"
        >
          <ng-container
            *ngIf="
              (formData?.options?.hideShowEmptyField &&
                (item.value || formData?.data[item.formControlName])) ||
              !formData?.options?.hideShowEmptyField
            "
          >
            <div class="custom-list__item" [ngSwitch]="true">
              <div class="custom-list__line label">{{ item.label }}</div>

              <div
                class="custom-list__line"
                *ngSwitchCase="item.type === 'static'"
                [innerHTML]="item.value"
              ></div>

              <div
                class="custom-list__line"
                *ngSwitchCase="
                  item.type === 'datepicker' ||
                  item.type === 'datepicker-range-start' ||
                  item.type === 'datepicker-range-end'
                "
              >
                <ng-container [ngSwitch]="dateLocale">
                  <ng-container *ngSwitchCase="'ru'">
                    {{
                      formData?.data[item.formControlName] | date: 'dd.MM.yyyy'
                    }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'en'">
                    {{
                      formData?.data[item.formControlName] | date: 'MM/dd/yyyy'
                    }}
                  </ng-container>
                </ng-container>
              </div>

              <div
                class="custom-list__line"
                *ngSwitchCase="
                  item.type === 'select' ||
                  item.type === 'select-multi' ||
                  item.type === 'select-filter'
                "
              >
                <mfpc-select-show-mode
                  [item]="item"
                  [optionList]="optionLists"
                  [formData]="formData"
                ></mfpc-select-show-mode>
              </div>

              <div class="custom-list__line" *ngSwitchDefault>
                {{ formData?.data[item.formControlName] }}
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <div
        [ngClass]="item.gridClasses"
        *ngIf="item.type === 'file' || item.type === 'file-multi'"
      >
        <div class="custom-list__item" [ngSwitch]="true">
          <div class="custom-list__line label">{{ item.label }}</div>
          <div
            class="custom-list__line"
            *ngSwitchCase="item.type === 'file' || item.type === 'file-multi'"
          >
            <mfpc-files
              [files]="formData?.data[item.formControlName]"
              (openFile)="openFile($event)"
            ></mfpc-files>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-container
  *ngIf="formData?.options?.editMode && formData?.options?.viewMode === 'edit'"
>
  <form
    [formGroup]="form"
    class="row"
    *ngIf="form && formData && formData?.template"
    (ngSubmit)="onSubmit()"
  >
    <ng-container *ngFor="let item of formData?.template">
      <ng-container *ngIf="!item?.edited && item.type !== 'static'">
        <div class="custom-list__item" [ngClass]="item.gridClasses">
          <div class="custom-list__line label">{{ item.label }}</div>
          <div class="custom-list__line">
            {{
              formData?.data
                ? formData?.data[item?.formControlName]
                : notFilledText
            }}
          </div>
        </div>
        <input type="hidden" [formControlName]="item?.formControlName" />
      </ng-container>

      <div
        class="custom-list__item"
        *ngIf="item.type === 'static'"
        [ngClass]="item.gridClasses"
      >
        <dl>
          <dt class="custom-list__line label">{{ item.label }}</dt>
          <dd class="custom-list__line" [innerHTML]="item.value"></dd>
        </dl>
      </div>

      <ng-container *ngIf="item?.edited">
        <div
          class="custom-form-field"
          *ngIf="item.type === 'text'"
          [ngClass]="item.gridClasses"
        >
          <mfpc-text-input
            formField
            [form]="form"
            [item]="item"
            [formData]="formData"
          ></mfpc-text-input>
        </div>

        <div
          class="custom-form-field"
          *ngIf="item.type === 'password'"
          [ngClass]="item.gridClasses"
        >
          <mfpc-password-input
            formField
            [form]="form"
            [formData]="formData"
            [item]="item"
          ></mfpc-password-input>
        </div>

        <div
          class="custom-form-field"
          *ngIf="item.type === 'number'"
          [ngClass]="item.gridClasses"
        >
          <mfpc-number-input
            formField
            [item]="item"
            [form]="form"
            [formData]="formData"
          ></mfpc-number-input>
        </div>

        <div
          class="custom-form-field"
          *ngIf="item.type === 'datepicker'"
          [ngClass]="item.gridClasses"
        >
          <mfpc-datepicker
            formField
            [item]="item"
            [form]="form"
            [formData]="formData"
            [min]="
              item.startDateMathDay || item.startDateMathDay === 0
                ? mathCurrentDateDay(item.startDateMathDay)
                : ''
            "
            [max]="
              item.endDateMathDay || item.endDateMathDay === 0
                ? mathCurrentDateDay(item.endDateMathDay)
                : ''
            "
          ></mfpc-datepicker>
        </div>

        <div
          class="custom-form-field"
          *ngIf="item.type === 'datepicker-range-start'"
          [ngClass]="item.gridClasses"
        >
          <mfpc-datepicker
            formField
            [item]="item"
            [form]="form"
            [formData]="formData"
            [min]="
              item.startDateMathDay || item.startDateMathDay === 0
                ? mathCurrentDateDay(item.startDateMathDay)
                : ''
            "
            [max]="
              item.endDateMathDay || item.endDateMathDay === 0
                ? mathCurrentDateDay(item.endDateMathDay)
                : form.get(item.endDateControl)?.value
            "
          ></mfpc-datepicker>
        </div>

        <div
          class="custom-form-field"
          *ngIf="item.type === 'datepicker-range-end'"
          [ngClass]="item.gridClasses"
        >
          <mfpc-datepicker
            formField
            [item]="item"
            [form]="form"
            [formData]="formData"
            [min]="form.get(item.startDateControl)?.value"
            [max]="
              item.endDateMathDay ? mathCurrentDateDay(item.endDateMathDay) : ''
            "
          ></mfpc-datepicker>
        </div>

        <div
          class="custom-form-field"
          *ngIf="item.type === 'file' || item.type === 'file-multi'"
          [ngClass]="item.gridClasses"
          [class]="
            form.get(item.formControlName)?.errors &&
            Object.keys(form.get(item.formControlName)?.errors).length &&
            form.get(item.formControlName).touched
              ? 'custom-form-field__invalid'
              : ''
          "
        >
          <mfpc-file-uploader
            [item]="item"
            [formData]="formData"
            [form]="form"
          ></mfpc-file-uploader>
        </div>

        <div
          class="custom-form-field"
          *ngIf="item.type === 'textarea'"
          [ngClass]="item.gridClasses"
        >
          <mfpc-textarea
            formField
            [item]="item"
            [form]="form"
          ></mfpc-textarea>
        </div>

        <div
          class="custom-form-field"
          *ngIf="item.type === 'select'"
          [ngClass]="item.gridClasses"
        >
          <mfpc-select
            formField
            [item]="item"
            [form]="form"
            [options]="
              item?.optionListRequestAlias &&
              optionLists &&
              optionLists[item?.optionListRequestAlias] &&
              !item?.selectParentTree
                ? controlsFilterOptionList[item.formControlName]
                  || optionLists[item?.optionListRequestAlias].optionList
                : !item?.optionListRequestAlias && item?.selectParentTree
                  ? filterParentGroup(
                      controlsFilterOptionList[item.formControlName] ||
                      item.optionList
                    )
                  : controlsFilterOptionList[item.formControlName]
                    || item.optionList
            "
          ></mfpc-select>
        </div>

        <div class="custom-form-field"
          *ngIf="item.type === 'select-filter'"
          [ngClass]="item.gridClasses"
        >
          <mfpc-select-filter
            formField
            [item]="item"
            [form]="form"
            [options]="
              item?.optionListRequestAlias &&
              optionLists &&
              optionLists[item?.optionListRequestAlias]
                ? controlsFilterOptionList[item.formControlName]
                  || optionLists[item?.optionListRequestAlias].optionList
                : controlsFilterOptionList[item.formControlName]
                  || item.optionList
            "
          ></mfpc-select-filter>
        </div>

        <div
          class="custom-form-field"
          *ngIf="item.type === 'radio'"
          [ngClass]="item.gridClasses"
        >
          <mfpc-radio-group
            formField
            [item]="item"
            [form]="form"
          ></mfpc-radio-group>
        </div>

        <div
          *ngIf="item.type === 'checkbox'"
          [ngClass]="item.gridClasses"
          class="custom-form-field"
        >
          <p-checkbox
            [binary]="true"
            [inputId]="item.formControlName"
            [formControlName]="item.formControlName"
          ></p-checkbox>
          <label for="{{ item.formControlName }}"> {{ item.label }}</label>
        </div>

        <div
          class="container-lg contacts custom-form-field"
          *ngIf="item.type === 'arr-smart'"
          [ngClass]="item.gridClasses"
        >
          <mfpc-arr-smart
            [item]="item"
            [form]="form"
            [formData]="formData"
            [filterOptionListAlias]="filterOptionListAlias.bind(this)"
            [filterOptionList]="filterOptionList.bind(this)"
            [reloadFilterOptionListAlias]="reloadFilterOptionListAlias.bind(this)"
            [reloadFilterOptionList]="reloadFilterOptionList.bind(this)"
            [controlsFilterOptionList]="controlsFilterOptionList"
            [optionList]="optionLists"
            (addSmartGroup)="addSmartFormGroup($event)"
            (removeSmartGroup)="removeSmartPrimeGroup($event)"
          ></mfpc-arr-smart>
        </div>

        <div class="custom-form-field"
             [ngClass]="item.gridClasses"
             *ngIf="item.type === 'static-files'"
        >
          <label class="custom-form-field__label">{{ item.label }}</label>
          <div class="custom-form-field__static-files">
            <mfpc-files
              [ngStyle]="{ padding: '10px 10px 0', display: 'block' }"
              [files]="item.files"
              (openFile)="openStaticFile($event)"
            ></mfpc-files>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </form>
</ng-container>
